export const BenefitsGrayShipment = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 41.5 36.212">
		<g id="Grupo_42" data-name="Grupo 42" transform="translate(0.5 0.5)">
			<g id="Grupo_55" data-name="Grupo 55" transform="translate(5.288 0)">
				<g id="Grupo_54" data-name="Grupo 54">
					<path
						id="Trazado_40"
						data-name="Trazado 40"
						d="M1066.37-427.283a.175.175,0,0,0-.007-.021,1.506,1.506,0,0,0-.1-.3c-.005-.012-.007-.026-.013-.037l-3.235-6.448a1.468,1.468,0,0,0-1.311-.81h-4.912a9.589,9.589,0,0,0,1.684-5.428,9.676,9.676,0,0,0-9.676-9.654,9.672,9.672,0,0,0-9.664,9.4h-6.475a1.467,1.467,0,0,0-1.467,1.467v4.348h2.934v-2.882h5.376c.025.085.058.168.085.252.035.109.07.219.11.327.057.156.119.308.183.459.043.1.084.2.131.3.073.156.153.308.234.46.048.089.093.18.142.267.1.166.2.326.3.486.044.067.084.136.13.2a9.823,9.823,0,0,0,1.033,1.254c.057.059.118.113.177.17.134.131.27.262.412.385.077.068.159.13.237.194.13.105.26.211.4.31.089.066.18.126.271.189.132.091.265.18.4.263.1.061.2.117.3.174.137.077.273.151.414.222.1.053.209.1.315.153.141.065.285.127.431.185.108.044.216.087.326.127.15.055.3.1.455.15.11.034.218.069.329.1.161.043.325.078.489.114.106.022.213.048.319.067.184.032.369.055.554.077.092.011.182.027.274.035.279.025.56.039.845.039.313,0,.623-.016.932-.046.1-.01.2-.028.3-.042.172-.022.346-.039.517-.071v8.8h-6.987c-.02-.017-.044-.03-.064-.048a4.305,4.305,0,0,0-.551-.422l-.019-.011a4.244,4.244,0,0,0-.609-.307c-.039-.016-.077-.034-.115-.049a4.184,4.184,0,0,0-.649-.188c-.043-.009-.086-.016-.13-.023a4.118,4.118,0,0,0-.705-.068,4.167,4.167,0,0,0-.7.067c-.05.009-.1.017-.15.027a4.205,4.205,0,0,0-.652.189c-.035.014-.067.03-.1.044a4.184,4.184,0,0,0-.55.278c-.035.021-.071.04-.106.062a4.161,4.161,0,0,0-.537.411c-.016.014-.035.024-.049.038h-3.745v-2.177h-2.934v3.644a1.467,1.467,0,0,0,1.467,1.467h3.87c0,.05-.012.1-.012.147a4.2,4.2,0,0,0,4.2,4.189,4.2,4.2,0,0,0,4.2-4.189c0-.049-.01-.1-.011-.147h9.383c0,.05-.011.1-.011.147a4.2,4.2,0,0,0,4.2,4.189,4.2,4.2,0,0,0,4.2-4.189c0-.05-.011-.1-.012-.147h2.271a1.468,1.468,0,0,0,1.467-1.467v-6.412A1.431,1.431,0,0,0,1066.37-427.283Zm-25.651,9.581a1.262,1.262,0,0,1-1.269-1.254,1.2,1.2,0,0,1,.24-.731,1.2,1.2,0,0,1,.46-.381,1.305,1.305,0,0,1,1.576.363l.06.077a1.231,1.231,0,0,1,.194.672A1.259,1.259,0,0,1,1040.719-417.7Zm17.6-14.261h2.476l1.762,3.514h-4.238Zm-6.87-2.188a6.8,6.8,0,0,1-1.926.5,6.815,6.815,0,0,1-.726.04,6.776,6.776,0,0,1-6.67-5.714,6.774,6.774,0,0,1-.072-1,6.738,6.738,0,0,1,6.742-6.72,6.74,6.74,0,0,1,6.743,6.721,6.653,6.653,0,0,1-3.116,5.655A6.244,6.244,0,0,1,1051.448-434.151Zm7.024,16.449a1.26,1.26,0,0,1-1.263-1.254,1.2,1.2,0,0,1,.24-.732c.027-.038.062-.066.092-.1a1.3,1.3,0,0,1,1.945.082,1.221,1.221,0,0,1,.254.749A1.262,1.262,0,0,1,1058.472-417.7Zm5-4.336h-2.147c-.01-.009-.024-.016-.034-.026a4.193,4.193,0,0,0-.568-.434l-.061-.036a4.106,4.106,0,0,0-.6-.3c-.026-.011-.05-.024-.077-.034a4.115,4.115,0,0,0-.662-.193l-.144-.026a4.188,4.188,0,0,0-.7-.067,4.148,4.148,0,0,0-.7.067l-.149.027a4.2,4.2,0,0,0-.651.189c-.034.014-.067.03-.1.044a4.337,4.337,0,0,0-.55.278c-.035.022-.072.04-.106.062a4.113,4.113,0,0,0-.538.412c-.015.014-.033.023-.048.037h-2.147v-9.848l.135-.077h1.766v4.981a1.467,1.467,0,0,0,1.467,1.467h6.617Z"
						transform="translate(-1031.19 449.98)"
						fill="#2C2C2C"
						stroke="rgba(0,0,0,0)"
						stroke-width="1"
					/>
				</g>
			</g>
			<g id="Grupo_57" data-name="Grupo 57" transform="translate(0 16.574)">
				<g id="Grupo_56" data-name="Grupo 56">
					<path
						id="Trazado_41"
						data-name="Trazado 41"
						d="M973.1-269.234H962.652a1.468,1.468,0,0,0-1.467,1.467,1.468,1.468,0,0,0,1.467,1.467H973.1a1.468,1.468,0,0,0,1.467-1.467A1.467,1.467,0,0,0,973.1-269.234Z"
						transform="translate(-961.185 269.234)"
						fill="#2C2C2C"
						stroke="rgba(0,0,0,0)"
						stroke-width="1"
					/>
				</g>
			</g>
			<g id="Grupo_59" data-name="Grupo 59" transform="translate(2.424 21.3)">
				<g id="Grupo_58" data-name="Grupo 58">
					<path
						id="Trazado_42"
						data-name="Trazado 42"
						d="M997.112-217.7h-8.028a1.468,1.468,0,0,0-1.467,1.467,1.468,1.468,0,0,0,1.467,1.467h8.028a1.467,1.467,0,0,0,1.467-1.467A1.468,1.468,0,0,0,997.112-217.7Z"
						transform="translate(-987.617 217.698)"
						fill="#2C2C2C"
						stroke="rgba(0,0,0,0)"
						stroke-width="1"
					/>
				</g>
			</g>
			<line
				id="Línea_1"
				data-name="Línea 1"
				y1="10.545"
				transform="translate(8.222 15.22)"
				fill="none"
				stroke="rgba(0,0,0,0)"
				stroke-width="1"
			/>
			<path
				id="Trazado_43"
				data-name="Trazado 43"
				d="M1186.461-364.692l2.232,1.959,4.747-4.557"
				transform="translate(-1166.935 374.873)"
				fill="none"
				stroke="#2C2C2C"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2.5"
			/>
		</g>
	</svg>
);
